export const PROD_BASE_URL = process.env.REACT_APP_PROD_BASE_URL!;
export const PROD_EMAIL = process.env.REACT_APP_PROD_EMAIL!;
export const PROD_PASSWORD = process.env.REACT_APP_PROD_PASSWORD!;
export const SAND_BASE_URL = process.env.REACT_APP_SAND_BASE_URL!;
export const SAND_EMAIL = process.env.REACT_APP_SAND_EMAIL!;
export const SAND_PASSWORD = process.env.REACT_APP_SAND_PASSWORD!;
